/**
 * Stub workouts shown when the bridge is unavailable (browser preview, sideload
 * before HealthKit auth, airplane-mode pool deck before remote bundle reaches
 * the device). Used as the placeholder dataset while developing visualizations.
 */
import type { WorkoutSummary } from "@contract/types";

const yesterday = new Date(Date.now() - 24 * 3600 * 1000);
const yesterdayEnd = new Date(yesterday.getTime() + 52 * 60 * 1000);

export const STUB_WORKOUTS: WorkoutSummary[] = [
  {
    uuid: "stub-0001",
    activityType: "swimming",
    startDate: yesterday.toISOString(),
    endDate: yesterdayEnd.toISOString(),
    durationSeconds: 52 * 60,
    totalDistance: { value: 1825, unit: "m" },
  },
];
